// Imports in the browser: Scrivener (`design-docs/Scrivener import in the browser — design.md`), Scapple and Word.
export { convertRTF, rtfPlainText, rtfParagraphs, type RTFConversion, type RTFAnchor, type RTFAnchorKind, type RTFParagraph } from './rtf.ts';
export { scrivenerScriptFountain, classifyScript, scriptElement, classifyUSPlay, classifyUKPlay, scriptFormatNamed, isActOrSceneHeading } from './scrivenerScript.ts';
export { parseXML, XMLNode, XMLError } from './xmlTree.ts';
export {
  ScrivenerPackage, ScrivenerError, fileMapFrom, parseScrivenerDate, isRootFolder,
  type FileMap, type BinderItem, type ScrivCollection, type CustomField, type Keyword, type ScrivOption, type Snapshot,
} from './scrivenerPackage.ts';
export {
  ScrivenerImport, importScrivenerPackage, importScrivenerPackageSync, scrivenerFields, isScreenplay, olderCopyReason, normalisedWords,
  scrivenerNodeID, importedSignature, mimeType, SCRIVENER_SOURCE,
  type ScrivenerImportOptions, type ScrivenerImportReport, type ScrivenerImportResult, type ImportIssue, type ImportedAttachment,
} from './scrivenerImporter.ts';
export { encodeImportBase, decodeImportBase, readImportBase, sameValue, IMPORT_BASE_KEY, type ImportBase } from './importBase.ts';
export { mergeField, encodeFieldBase, decodeFieldBase, SCRIVENER_FIELDS_KEY } from './fieldMerge.ts';
export { scrivenerCommentInk, inkCategoryName } from './commentColors.ts';
export { scappleColorInk, scappleIds, scappleImport, scappleSummary, type ScappleReport } from './scapple.ts';
export {
  readWordDocument, isLegacyWord, iso8601, WordImportError, WordNumbering, wordHighlightInk,
  type WordDocument, type WordParagraph, type WordRole, type WordAnchor, type WordComment, type WordFiles,
} from './wordDocument.ts';
export {
  buildWordOutline, chapterNumber, chapterLike, isPartLike, matterKind, romanValue, sectionOptionID, wordCountOf,
  type WordOutline, type WordNode, type WordSectionType,
} from './wordOutline.ts';
export { importWordDocument, WORD_SOURCE, type WordImportOptions, type WordImportReport, type WordImportResult } from './wordImporter.ts';
